import Swiper from "swiper";
import {
    A11y,
    Autoplay,
    EffectFade,
    Navigation,
    Pagination,
} from "swiper/modules";
import $ from "jquery";

const SwipeSlider = () => {
    new Swiper(".js-post-swiper", {
        modules: [Navigation, Pagination, A11y],
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 24,
        breakpoints: {
            768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 24,
            },
        },
        mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
        },
        navigation: {
            nextEl: ".post-swiper__button-next",
            prevEl: ".post-swiper__button-prev",
        },
        pagination: {
            el: ".post-swiper__pagination",
            type: "bullets",
            clickable: true,
        },
        on: {
            slideChange: function () {
                let currentSlide = this.realIndex + 1;
                let activeSlideView;

                $(window).width() < 1024
                    ? (activeSlideView = Math.ceil(currentSlide))
                    : (activeSlideView = Math.ceil(currentSlide / 3));

                document.querySelector(
                    ".post-swiper .current-slide"
                ).innerHTML = activeSlideView;
            },
            afterInit: function () {
                let numOfSlides = this.pagination.bullets.length;
                document.querySelector(".post-swiper .total-slides").innerHTML =
                    numOfSlides;
            },
            resize: function () {
                let numOfSlides = this.pagination.bullets.length;
                document.querySelector(".post-swiper .total-slides").innerHTML =
                    numOfSlides;
            },
        },
    });

    new Swiper(".js-events-swiper", {
        modules: [Navigation, Pagination, A11y],
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 24,
        navigation: {
            nextEl: ".events-carousel__button-next",
            prevEl: ".events-carousel__button-prev",
        },
        pagination: {
            el: ".events-carousel__pagination",
            type: "bullets",
            clickable: true,
        },
        on: {
            slideChange: function () {
                let currentSlide = this.realIndex + 1;
                document.querySelector(
                    ".events-carousel .current-slide"
                ).innerHTML = currentSlide;
            },
            beforeInit: function () {
                let numOfSlides = this.wrapperEl.querySelectorAll(
                    ".events-carousel .swiper-slide"
                ).length;
                let totalViews = Math.ceil(numOfSlides / 3);
                document.querySelector(
                    ".events-carousel .total-slides"
                ).innerHTML = totalViews;
            },
        },
    });

    const areaSwiper = new Swiper(".js-business-swiper", {
        modules: [Navigation, Pagination, A11y, EffectFade],
        slidesPerView: 1,
        speed: 1000,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        pagination: {
            el: ".business-areas__pagination",
            type: "bullets",
            clickable: true,
        },
        allowTouchMove: false,
        on: {
            slideChange: function () {
                let currentSlide = this.realIndex + 1;

                document.querySelector(
                    ".business-areas .current-slide"
                ).innerHTML = currentSlide;

                $(".business-areas__control-button").each(function () {
                    if ($(this).data("index") === areaSwiper.realIndex) {
                        $(this).addClass(
                            "business-areas__control-button--active"
                        );
                    } else {
                        $(this).removeClass(
                            "business-areas__control-button--active"
                        );
                    }
                });

                $(".business-areas__slide").each(function () {
                    if ($(this).data("index") === areaSwiper.realIndex) {
                        $(".business-areas__video").prop("autoplay", false);

                        $(this)
                            .find(".business-areas__video")
                            .prop("autoplay", true);
                        $(this).find(".business-areas__video").trigger("load");
                    }
                });
            },
            beforeInit: function () {
                let numOfSlides = this.wrapperEl.querySelectorAll(
                    ".business-areas .swiper-slide"
                ).length;

                document.querySelector(
                    ".business-areas .total-slides"
                ).innerHTML = numOfSlides;
            },
        },
    });

    const lastSlide = $(".business-areas .swiper-slide").length - 1;

    $(".business-areas__button-next").on("click", function () {
        if (areaSwiper.isEnd) {
            areaSwiper.slideTo(0, 1000);
        } else {
            areaSwiper.slideNext(1000);
        }
    });

    $(".business-areas__button-prev").on("click", function () {
        if (areaSwiper.isBeginning) {
            areaSwiper.slideTo(lastSlide, 1000);
        } else {
            areaSwiper.slidePrev(1000);
        }
    });

    $(".business-areas__control-button").on("click", function () {
        $(".business-areas__control-button").removeClass(
            "business-areas__control-button--active"
        );
        $(this).addClass("business-areas__control-button--active");

        let dataIndex = $(this).data("index");
        areaSwiper.slideTo(dataIndex, 1000);

        // $("html, body").scrollTop($("#business-swiper").offset().top - 100);
    });
};

export default SwipeSlider;
